// extracted by mini-css-extract-plugin
module.exports = {"container":"bB_x","privacyPolicy":"bB_d9"};